// @flow

import { removeAuthInLink } from 'common/remove-auth-in-link'

import type { User } from '@foxford/foxford-js-sdk'

export const onUserSetCallbackFree = (user: User) => {
  if (user.isLoggedIn()) {
    removeAuthInLink()
  }
}
